import React from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';

interface VideoProps extends Omit<ReactPlayerProps, 'light'> {
  thumbnail?: any;
}

const Video = ({ thumbnail, ...props }: VideoProps) => {
  // N.B controls are required for users to play Vimeo videos
  return <ReactPlayer className="w-full" {...props} light={thumbnail} controls width="100%" height="100%" />;
};

export default Video;
